import * as React from 'react';
import Carousel from '../components/home/Carousel';
import Films from '../components/home/Films';
import Serials from '../components/home/Serials';
import Trailers from '../components/home/Trailers';
import Tvs from '../components/home/Tvs';
import Tracks from '../components/home/Tracks';
import Clips from '../components/home/Clips';
import Albums from '../components/home/Albums';
import Banner from '../components/parts/Banner';
import PopupBanner from '../components/PopupBanner';
import Helmet from 'react-helmet';

export default class Home extends React.Component<any, any> {

    render() {
        return (
            <div className="i-body main-body">
                <Helmet>
                    <title>{window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>
                </Helmet>
                <div className="background">
                    <Banner className="basic" place={41} />
                </div>
                
                <div className="container v-index" style={{ position: "relative" }}>
                    <div className="wrapper">
                        <Carousel />
                        <Films />
                        <Banner className="banner235" place={1} />
                        <Serials />
                        <Trailers showFilters={true} />
                        <Banner className="banner235" place={2} />
                        <Tracks />
                        <Clips />
                        <Albums />
                      
                    </div>
                    <Banner className="banner300 mt-0" place={4} />
                </div>

                <PopupBanner place={42} />

                {/* <div className="inner-trailer">
                            <Tvs />
                        </div> */}
            </div>
        );
    }
}